import { Route } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { SectionTag } from "../components/SectionLabel";

const STEPS = [
  { n: "01", title: "Primeiro contato", text: "Pelo WhatsApp ou formulário, você conta o essencial do seu caso." },
  { n: "02", title: "Primeiro atendimento", text: "Conversamos com atenção para entender o contexto por completo." },
  { n: "03", title: "Estratégia", text: "Definimos juntos a estratégia e os documentos iniciais necessários." },
  { n: "04", title: "Acompanhamento", text: "Seguimos próximos durante toda a demanda, com transparência total." },
];

export const ComoFunciona = () => (
  <section id="como-funciona" className="bg-cream py-24 lg:py-32" data-testid="como-funciona-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <Reveal>
        <SectionTag icon={Route} label="Como funciona" tone="brown" />
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-ink max-w-lg mb-16">
          Do primeiro contato ao acompanhamento.
        </h2>
      </Reveal>

      <div className="grid md:grid-cols-4 gap-10 relative">
        <div className="hidden md:block absolute top-6 left-0 right-0 h-px bg-line" />
        {STEPS.map((s, i) => (
          <Reveal key={s.n} delay={0.15 + i * 0.1} className="relative">
            <span className="font-mono text-xs text-teal-dark bg-cream relative z-10 pr-2">{s.n}</span>
            <h3 className="font-serif text-xl text-ink mt-5" data-testid={`step-title-${i}`}>
              {s.title}
            </h3>
            <p className="mt-2 text-sm text-ink-soft leading-relaxed">{s.text}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
